import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  editSpecialitiesActive: boolean;
}

export const Wrapper = styled.div`
  margin: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  height: 240px;
  width: 360px;
  position: relative;
  box-shadow: rgb(220, 220, 220) 0px 0px 15px;
  overflow: hidden;

  ${mediaMaxWidth.smallDesktop} {
    margin: 0 auto 10px auto;
    width: 650px;
    height: ${(props: IWrapperProps) =>
      props.editSpecialitiesActive ? "280px" : "unset"};
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 20px);

    .__react_component_tooltip {
      display: none !important;
    }
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;

  ${mediaMaxWidth.phone} {
    padding: 5px;
    font-size: 0.9em;
  }
`;

interface IBodyProps {
  noData: boolean;
}

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${(props: IBodyProps) =>
    props.noData ? "10px 30px" : "10px 10px 0 10px"};
  justify-content: ${(props: IBodyProps) => props.noData && "center"};
  align-items: ${(props: IBodyProps) => props.noData && "center"};
  font-size: ${(props: IBodyProps) => props.noData && "0.95em"};
  text-align: ${(props: IBodyProps) => props.noData && "center"};

  ${mediaMaxWidth.smallDesktop} {
    padding: ${(props: IBodyProps) => props.noData && "85px 30px !important"};
  }

  ${mediaMaxWidth.phone} {
    padding: 10px 5px 0 5px;
  }
`;

export const Speciality = styled.div`
  display: flex;
  height: 44.25px;
  align-items: center;
  font-size: 0.95em;

  svg {
    color: #27ae60;
  }
`;

export const SpecialityText = styled.div`
  padding-left: 15px;
  width: 305px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMaxWidth.smallDesktop} {
    width: 595px;
  }

  ${mediaMaxWidth.tablet} {
    width: calc(100vw - 75px);
  }
`;
